<template>
  <div class="form-group row">
    <label class="col-2 text-right">保障公式</label>
    <div class="col-10 d-inline-grid">
      <!-- 保障公式-1 -->
      <div class="checkbox radio-inline mb-15">
        <input 
          type="checkbox" 
          id="formularType-1"
          :class="{ 'is-invalid': validate.isPositionErr }"
          v-model="form.position"
          value="0"
        />
        <label class="hide-label" for="formularType-1"></label>
        <span class="lh-40 ml-50">以</span>
        <select
          class="form-control form-control-inline form-wide w-250"
          :class="{ 'is-invalid': validate.isCalc_basisErr1 }"
          v-model="form.calc_basis1"
        >
          <option
            v-for="item in pageControl.multiConditionBasis"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">的</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isPeriod_lowerErr1 }"
          v-model="form.period_lower1"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isUnit_lowerErr1 }"
          v-model="form.unit_lower1"
        >
          <option
            v-for="item in this.pageControl.noDollarUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">，最高給付上限</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          v-model="form.benefit_max"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <span class="ml-15 lh-40">萬元</span>
      </div>

      <!-- 保障公式-2 -->
      <div class="checkbox radio-inline mb-15">
        <input 
          type="checkbox" 
          id="formularType-2"
          :class="{ 'is-invalid': validate.isPositionErr }"
          v-model="form.position"
          value="1"
        />
        <label class="hide-label" for="formularType-2"></label>
        <span class="lh-40 ml-50">每</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isYear_progErr2 }"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
          v-model="form.yearprogression2"
        />
        <span class="lh-40">年 以</span>
        <select
          class="form-control form-control-inline form-wide w-250"
          :class="{ 'is-invalid': validate.isCalc_basisErr2 }"
          v-model="form.calc_basis2"
        >
          <option
            v-for="item in pageControl.multiConditionBasis"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isInterestTypeErr2 }"
          v-model="form.interestType2"
        >
          <option value=""></option>
          <option
            v-for="item in pageControl.interestTypes"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">的</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isPeriod_lowerErr2 }"
          v-model="form.period_lower2"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isUnit_lowerErr2 }"
          v-model="form.unit_lower2"
        >
          <option
            v-for="item in this.pageControl.noDollarUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isFormulaTrend2 }"
          v-model="form.formulaTrend2"
        >
          <option value=""></option>
          <option
            v-for="item in pageControl.formulaTrends"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
      </div>

      <!-- 保障公式-3 -->
      <div class="checkbox radio-inline mb-15">
        <input 
          type="checkbox" 
          id="formularType-3"
          :class="{ 'is-invalid': validate.isPositionErr }"
          v-model="form.position"
          value="2"
        />
        <label class="hide-label" for="formularType-3"></label>
        <span class="lh-40 ml-50">每</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isYear_progErr3 }"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
          v-model="form.yearprogression3"
        />
        <span class="lh-40">年 以</span>
        <select
          class="form-control form-control-inline form-wide w-250"
          :class="{ 'is-invalid': validate.isCalc_basisErr3 }"
          v-model="form.calc_basis3"
        >
          <option
            v-for="item in pageControl.multiConditionBasis"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isInterestTypeErr3 }"
          v-model="form.interestType3"
        >
          <option value=""></option>
          <option
            v-for="item in pageControl.interestTypes"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">的</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isPeriod_lowerErr3 }"
          v-model="form.period_lower3"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isUnit_lowerErr3 }"
          v-model="form.unit_lower3"
        >
          <option
            v-for="item in this.pageControl.noDollarUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isFormulaTrend3 }"
          v-model="form.formulaTrend3"
        >
          <option value=""></option>
          <option
            v-for="item in pageControl.formulaTrends"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
      </div>

      <!-- 保障公式-4 -->
      <div class="checkbox radio-inline mb-15">
        <input 
          type="checkbox" 
          id="formularType-4"
          :class="{ 'is-invalid': validate.isPositionErr }"
          v-model="form.position"
          value="3"
        />
        <label class="hide-label" for="formularType-4"></label>
        <span class="lh-40 ml-50">每</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isYear_progErr4 }"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
          v-model="form.yearprogression4"
        />
        <span class="lh-40">年 以</span>
        <select
          class="form-control form-control-inline form-wide w-250"
          :class="{ 'is-invalid': validate.isCalc_basisErr4 }"
          v-model="form.calc_basis4"
        >
          <option
            v-for="item in pageControl.multiConditionBasis"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isInterestTypeErr4 }"
          v-model="form.interestType4"
        >
          <option value=""></option>
          <option
            v-for="item in pageControl.interestTypes"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">的</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isPeriod_lowerErr4 }"
          v-model="form.period_lower4"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isUnit_lowerErr4 }"
          v-model="form.unit_lower4"
        >
          <option
            v-for="item in this.pageControl.noDollarUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isFormulaTrend4 }"
          v-model="form.formulaTrend4"
        >
          <option value=""></option>
          <option
            v-for="item in pageControl.formulaTrends"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
      </div>


      <!-- 保障公式-5 -->
      <div class="checkbox radio-inline mb-15">
        <input 
          type="checkbox" 
          id="formularType-5"
          :class="{ 'is-invalid': validate.isPositionErr }"
          v-model="form.position"
          value="4"
        />
        <label class="hide-label" for="formularType-5"></label>
        <span class="lh-40 ml-50">每</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isYear_progErr5 }"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
          v-model="form.yearprogression5"
        />
        <span class="lh-40">年 以</span>
        <select
          class="form-control form-control-inline form-wide w-250"
          :class="{ 'is-invalid': validate.isCalc_basisErr5 }"
          v-model="form.calc_basis5"
        >
          <option
            v-for="item in pageControl.multiConditionBasis"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isInterestTypeErr5 }"
          v-model="form.interestType5"
        >
          <option value=""></option>
          <option
            v-for="item in pageControl.interestTypes"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">的</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isPeriod_lowerErr5 }"
          v-model="form.period_lower5"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isUnit_lowerErr5 }"
          v-model="form.unit_lower5"
        >
          <option
            v-for="item in this.pageControl.noDollarUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isFormulaTrend5 }"
          v-model="form.formulaTrend5"
        >
          <option value=""></option>
          <option
            v-for="item in pageControl.formulaTrends"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
      </div>

      <!-- 保障公式-6 -->
      <div class="checkbox radio-inline mb-15">
        <input 
          type="checkbox" 
          id="formularType-6"
          :class="{ 'is-invalid': validate.isPositionErr }"
          v-model="form.position"
          value="5"
        />
        <label class="hide-label" for="formularType-6"></label>
        <span class="lh-40 ml-50">每</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isYear_progErr6 }"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="3"
          v-model="form.yearprogression6"
        />
        <span class="lh-40">年 以</span>
        <select
          class="form-control form-control-inline form-wide w-250"
          :class="{ 'is-invalid': validate.isCalc_basisErr6 }"
          v-model="form.calc_basis6"
        >
          <option
            v-for="item in pageControl.multiConditionBasis"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">的</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isPeriod_lowerErr6 }"
          v-model="form.period_lower6"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isUnit_lowerErr6 }"
          v-model="form.unit_lower6"
        >
          <option
            v-for="item in this.pageControl.noDollarUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">X</span>
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isMultiplierErr }"
          v-model="form.multiplier"
        >
          <option value=""></option>
          <option
            v-for="item in pageControl.cumulativeFormulaMultipliers"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
      </div>

      <!-- 保障公式-7 -->
      <div class="checkbox radio-inline mb-15">
        <input 
          type="checkbox" 
          id="formularType-7"
          :class="{ 'is-invalid': validate.isPositionErr }"
          v-model="form.position"
          value="6"
        />
        <label class="hide-label" for="formularType-7"></label>
        <select
          class="form-control form-control-inline form-wide w-250 ml-50"
          v-model="form.append"
        >
          <option
            v-for="item in pageControl.appends"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
      </div>

    </div>
  </div>
</template>
<script>
import { commonMixin } from "@/mixins/common";
export default {
  name: "CoveragePageFormulaMulti",
  mixins: [commonMixin],
  data() {
    return {};
  },
  props: {
    pageControl: {
      type: Object,
      default: () => {
        return {};
      },
    },
    form: {
      type: Object,
      default: () => {
        return {};
      },
    },
    validate: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
